import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { REQUESTED_CATEGORIES_URL_PARAM_NAME } from '../../consts';
import { filterServicesBySelectedTab } from '../../utils/services/services';
import {
  EnrichedService,
  FilterOption,
  FilterServicesByOptions,
} from '../../types/types';
import { WidgetViewModel } from '../../viewModel/viewModel';
import settingsParams from '../../components/BookOnline/settingsParams';
import { setUrlQueryParam } from '@wix/bookings-catalog-calendar-viewer-utils';
import { BookingsAPI } from '../../api/BookingsApi';
import { getAdditionalServicesData } from '../getAdditionalServicesData/getAdditionalServicesData';

export type OnFilterOptionSelectedAction = (
  selectedFilterOption: FilterOption,
) => void;

export const createOnFilterOptionSelectedAction = ({
  widgetViewModel,
  services,
  setProps,
  flowAPI,
  bookingsApi,
}: {
  services: EnrichedService[];
  widgetViewModel: WidgetViewModel;
  setProps: Function;
  flowAPI: ControllerFlowAPI;
  bookingsApi: BookingsAPI;
}): OnFilterOptionSelectedAction => {
  return async (selectedFilterOption: FilterOption) => {
    const { settings } = flowAPI;
    const filterServicesBy = settings.get(settingsParams.filterServicesBy);
    if (filterServicesBy === FilterServicesByOptions.CATEGORIES) {
      setUrlQueryParam({
        wixCodeApi: flowAPI.controllerConfig.wixCodeApi,
        key: REQUESTED_CATEGORIES_URL_PARAM_NAME,
        value: selectedFilterOption.id,
      });
    }

    const newFilterOptions = widgetViewModel.filterOptions.map(
      (filterOption: FilterOption) => ({
        ...filterOption,
        isSelected: filterOption.id === selectedFilterOption.id,
      }),
    );

    const servicesToDisplay = filterServicesBySelectedTab({
      filterOptions: newFilterOptions,
      services,
      settings,
    });

    const { coursesAvailability, services: populatedServices } =
      await getAdditionalServicesData({
        bookingsApi,
        services: servicesToDisplay,
      });

    widgetViewModel.filterOptions = newFilterOptions;
    widgetViewModel.services = populatedServices;
    widgetViewModel.coursesAvailability = coursesAvailability;

    setProps({
      widgetViewModel: { ...widgetViewModel },
    });
  };
};
